/* Pagina /cart (template cart, teto proprio de 8KB no gate - nao entra no core
 * de 16KB). Faz o que o Liquid nao alcanca: estimador de frete por CEP, chips de
 * presenteado (PII, so em memoria), endereco inline e o total estimado.
 *
 * Sem este arquivo a pagina continua comprando: form nativo POST /cart com
 * updates[], note, attributes e name="checkout". Markup: tudo vive na section
 * (estados renderizados escondidos + <template>); aqui so a logica. Os ganchos
 * data-mw-* curtos (ce, ee, go, gf, tv, br...) sao o preco do teto de 8KB: a
 * classe CSS ao lado de cada um diz o que a caixa e.
 *
 * Contratos honrados:
 * - snapshot localStorage mw_compra_frete lido pelo drawer (mw-cart.js): cep JA
 *   formatado, pesoGramas/subtotalCentavos IGUAIS aos do /cart.js (por isso a
 *   cotacao so vira snapshot depois do primeiro evento mw:cart) e cotacao da
 *   MESMA tupla que esta na tela. CEP herdado do chip de um presenteado nunca vai
 *   a disco: e endereco de terceiro, so memoria.
 * - GET /apps/curador/frete responde {ok,uf,opcoes[],gratisAcimaCentavos} |
 *   {ok:false,erro} (cep_invalido, fora_de_area, sem_preco, indisponivel).
 */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-mw-compra]');
  if (!raiz) return;
  var T = {};
  try { T = JSON.parse(document.getElementById('mw-compra-i18n').textContent); } catch (e) { return; }

  /* Arbitragem A2 do plano aprovado (2026-08-03): o permalink de prefill
     SUBSTITUI o carrinho e a regressao do prefill segue aberta na Shopify ->
     PLANO B e o default. Virar true so troca o trio de textos (_planob ->
     _prefill); o botao Finalizar continua sendo submit nativo name="checkout". */
  var PREFILL = false;
  /* Fase T4 CONCLUIDA: a rota existe (painel/src/app/api/curador/conta/
     presenteados/[id]/endereco/route.ts, POST com enderecoEntradaSchema estrito).
     Falha de rede nao trava nada: o endereco segue valendo local e viaja no
     checkout. */
  var SALVAR_ENDERECO = true;

  var LOGADO = raiz.getAttribute('data-logado') === '1';
  var API = '/apps/curador/conta';
  var JSN = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function q(n) { return raiz.querySelector('[data-mw-' + n + ']'); }
  function campo(n) { return raiz.querySelector('[data-f="' + n + '"]'); }
  /* mostra/esconde um gancho e, de quebra, escreve nele: e o par que mais se
     repete nesta tela (o teto de 8KB nao perdoa duas chamadas onde cabe uma) */
  function mt(n, on, t) {
    var e = q(n);
    if (!e) return;
    e.hidden = !on;
    if (t != null) e.textContent = t;
  }
  function ve(n, on) {
    var e = raiz.querySelector('[data-mw-e="' + n + '"]');
    if (e) e.hidden = !on;
  }
  function fmt(s, m) { return (s || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return m[k] == null ? '' : m[k]; }); }
  function dig(s) { return String(s || '').replace(/\D/g, ''); }
  function fcep(s) { var d = dig(s).slice(0, 8); return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d; }
  function ler(n) { var e = campo(n); return e ? String(e.value).trim() : ''; }
  function clonar(n) { return raiz.querySelector('template[data-tpl="' + n + '"]').content.firstElementChild.cloneNode(true); }
  function slot(no, k, t) { var e = no.querySelector('[data-s="' + k + '"]'); if (e) e.textContent = t; return e; }
  function guardar(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* bloqueado */ } }
  function rj(r) { return r.json(); }
  /* m = metodo (POST sem ele; o PUT do email da pessoa salva passa aqui) */
  function post(u, b, m) { return fetch(u, { method: m || 'POST', headers: JSN, body: JSON.stringify(b) }); }
  function jget(u) { return fetch(u, { headers: JSN }).then(rj); }

  var moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function brl(c) { return moeda.format((c || 0) / 100); }

  var chk = q('presente-chk');
  var elCep = q('cep');
  if (!chk || !elCep) return; /* carrinho vazio: so a faixa de selos na tela */
  /* Email de quem recebe (o recado chega por ele). Nao existe no carrinho com
     presente de evento (main-cart.liquid): todo uso aqui passa por `em &&` ou
     emv(). EM e a regua do z.string().email() do servidor (presenteadoSchema e
     o que o painel valida no atributo): a validacao do type="email" aceitaria
     "ana@gmail", e o PUT com ele voltaria 400 sem a tela saber. */
  var em = q('em');
  var EM = /^(?!\.)(?!.*\.\.)[\w'+.-]*[\w+-]@([a-z\d][a-z\d-]*\.)+[a-z]{2,}$/i;
  /* De quem e o valor do campo: o id da pessoa salva cujo email ele e (veio da
     ficha dela, ou foi digitado com ela escolhida), ou null quando foi digitado
     sem pessoa salva. escolher() so apaga o que era da pessoa anterior. */
  var emDe = null;
  /* Pessoa escolhida que veio de um evento (semEmailPresente do GET
     /presenteados): o painel nunca manda o email a ela, entao o recado e o email
     saem da tela (pintarPresente) e o email nao vai a lugar nenhum. */
  function semEm() { var p = achar(st.sel); return !!(p && p.semEmailPresente); }
  /* o email do campo quando ele vale e esta na tela; senao vazio */
  function emv() { var v = em && !semEm() ? em.value.trim() : ''; return EM.test(v) ? v : ''; }
  /* O type="text" do campo nao tem validacao nativa (main-cart.liquid): quem
     aponta o email fora da regua no Finalizar e esta mensagem. So com o presente
     marcado e o campo na tela - escondido, travaria o submit sem mostrar onde. */
  function validar() {
    if (!em) return;
    var v = em.value.trim();
    em.setCustomValidity(chk.checked && !semEm() && v && !EM.test(v) ? T.email_invalido : '');
  }
  var st = {
    pres: [], sel: null, ends: {}, aberto: false, fonte: null, frete: null, opcao: null,
    /* tupla da cotacao que esta na tela: {cep, peso, sub, fonte}. E o que autoriza
       (ou nao) o snapshot - ver snapshot() */
    cot: null,
    sub: parseInt(raiz.getAttribute('data-sub'), 10) || 0,
    peso: parseInt(raiz.getAttribute('data-peso'), 10) || 0,
    vivo: false
  };
  var seq = 0;       /* geracao da cotacao: resposta velha nao pinta nem grava */
  var criando = false; /* POST de nova pessoa em voo (Enter + blur criavam duas) */
  /* As 27 UFs, a mesma regua do enderecoEntradaSchema do servidor. O %3 e o que
     impede casamento atravessado ("MA" dentro de "AM,AP"). */
  var UFS = 'AC,AL,AM,AP,BA,CE,DF,ES,GO,MA,MG,MS,MT,PA,PB,PE,PI,PR,RJ,RN,RO,RR,RS,SC,SE,SP,TO';

  if (PREFILL) {
    mt('es-selo', 1, T.selo_prefill);
    mt('end-nota', 1, T.end_nota_prefill);
  }

  /* ---------- pessoa da entrega ---------- */
  function achar(id) {
    for (var i = 0; i < st.pres.length; i++) if (st.pres[i].id === id) return st.pres[i];
    return null;
  }
  /* Pessoa efetiva: presenteado salvo ou a pessoa nova ainda sendo digitada. O
     endereco aplicado aqui no carrinho (st.ends) manda no que veio da conta. */
  function pessoa() {
    if (!LOGADO || !st.sel) return null;
    if (st.sel === 'novo') {
      var n = ler('nome');
      return n ? { id: null, nome: n, end: st.ends.novo || null, completo: !!st.ends.novo } : null;
    }
    var p = achar(st.sel);
    if (!p) return null;
    /* `completo` decide se a tela pode dizer ENDERECO SALVO. O endereco aplicado
       aqui ja passou pela regua de salvarEndereco; o que veio da conta so vale
       quando o SERVIDOR diz que vira remessa (enderecoCompleto - a rota devolve o
       campo justamente para o tema nao reimplementar a regra). Cadastro pela
       metade cai no ramo "sem endereco", que tem o botao de completar. */
    var e = st.ends[p.id];
    return { id: p.id, nome: p.nome, end: e || p.endereco || null, completo: e ? true : !!p.enderecoCompleto };
  }
  /* O GET da conta devolve endereco no vocabulario da conta (rua/numero/
     complemento); o carrinho grava no dele (endereco1/endereco2). Uma linha so
     resolve os dois sem adivinhar nada. */
  function linhas(e) {
    var comp = e.endereco2 || e.complemento;
    return [
      (e.endereco1 || e.rua || '') + (e.numero ? ', ' + e.numero : '') + (comp ? ', ' + comp : ''),
      (e.bairro ? e.bairro + ' · ' : '') + (e.cidade || '') + ' - ' + (e.uf || '') + ' · CEP ' + fcep(e.cep)
    ];
  }

  /* ---------- CEP -> endereco (ViaCEP, BrasilAPI de reserva) ----------
     COPIA DESTE BLOCO vive em assets/mw-envios.js (cards de destino da pagina de
     envios). Duplicado de PROPOSITO: os dois arquivos tem teto proprio no gate e o
     core de 16KB (carregado em toda pagina) nao tem folga pra um helper novo que
     so serve a duas telas. Mexeu aqui, mexa la.
     Vale para o CEP do ENDERECO do presenteado (data-f="cep"), nao para o do
     estimador (data-mw-cep): la nao ha endereco nenhum pra preencher.
     `fetch` sem header custom e requisito, nao descuido: header custom transforma
     a chamada em preflight e o ViaCEP nao responde OPTIONS. Falhou (CEP que nao
     existe, API fora, timeout)? SILENCIO: o cliente digita como sempre digitou. */
  var cepMem = {}; /* CEP -> promessa desta pageview: cacheia, deduplica em voo e nao rebate a API */
  var cepAu = {};  /* campos escritos pelo autocomplete, nao pelo cliente */
  var cepUlt = '';
  var cepT = 0;
  /* timeout curto: CEP fora do ar nao pode deixar o cliente esperando um campo que
     ele digita em 5 segundos. Navegador sem AbortSignal.timeout segue sem timeout
     em vez de estourar TypeError no meio do formulario. */
  function cepOpt() { return AbortSignal.timeout ? { signal: AbortSignal.timeout(4000) } : {}; }
  /* um parser pras duas APIs; o mapa diz como cada uma chama os quatro campos */
  function cepJson(u, m) {
    return fetch(u, cepOpt()).then(rj).then(function (j) {
      var e = {
        endereco1: j[m[0]] || '', bairro: j[m[1]] || '',
        cidade: j[m[2]] || '', uf: (j[m[3]] || '').toUpperCase()
      };
      /* CEP inexistente: o ViaCEP responde 200 com {erro:true} e a BrasilAPI, 404
         com corpo de erro. Sem UF nao ha resposta util em nenhum dos dois. */
      if (j.erro || e.uf.length !== 2) throw 0;
      return e;
    });
  }
  function cepBusca(c) {
    return cepMem[c] || (cepMem[c] = cepJson('https://viacep.com.br/ws/' + c + '/json/', ['logradouro', 'bairro', 'localidade', 'uf'])
      .catch(function () { return cepJson('https://brasilapi.com.br/api/cep/v2/' + c, ['street', 'neighborhood', 'city', 'state']); }));
  }
  /* Escreve so no campo vazio ou no que o proprio autocomplete escreveu (cepAu):
     digitacao do cliente nunca e sobrescrita, mas corrigir o CEP corrige junto o
     endereco que veio do CEP errado. Campo vazio na resposta (CEP de cidade
     inteira nao tem logradouro) nao apaga nada. */
  function cepAplicar(e) {
    var mudou = false, alvo = campo('endereco1'), f, c;
    /* as chaves de `e` SAO os quatro campos: nao ha lista pra manter em dois lugares */
    for (f in e) {
      c = campo(f);
      if (!c || !e[f] || (c.value.trim() && !cepAu[f])) continue;
      c.value = e[f];
      cepAu[f] = 1;
      mudou = true;
    }
    /* Nao ha campo de numero neste formulario: o rotulo do endereco1 e "Endereco e
       numero" e as duas APIs devolvem so o logradouro. Entao o cursor cai no FIM
       do que foi preenchido, que e exatamente onde o numero entra. So quando o
       cliente ainda esta no campo do CEP: se ele ja saiu dali, escolheu onde
       digitar e ninguem tira o cursor da mao dele. */
    if (mudou && alvo && document.activeElement === campo('cep')) {
      alvo.focus();
      alvo.setSelectionRange(alvo.value.length, alvo.value.length);
    }
  }
  function cepAuto() {
    var el = campo('cep'), c = dig(el && el.value);
    if (c === cepUlt) return; /* CEP nao mudou: nem reagenda nem repete a busca */
    cepUlt = c;
    clearTimeout(cepT);
    if (c.length !== 8) return;
    cepT = setTimeout(function () {
      cepBusca(c).then(function (e) {
        if (dig(campo('cep').value) === c) cepAplicar(e); /* resposta velha nao pinta sobre digitacao nova */
      }).catch(function () { /* silencio: a edicao manual segue livre */ });
    }, 250);
  }

  /* ---------- estimador ---------- */
  function escolhida() {
    var ops = st.frete ? st.frete.opcoes : [];
    for (var i = 0; i < ops.length; i++) if (ops[i].nome === st.opcao) return ops[i];
    return ops[0] || null;
  }
  function snapshot() {
    var o = escolhida(), c = st.cot;
    /* peso e subtotal tem que ser os MESMOS numeros do /cart.js, senao o drawer
       descarta o snapshot (e faz certo: cotacao velha e frete errado) */
    if (!o || !st.vivo || !c) return;
    /* ... e a cotacao na tela tem que ser DESTA tupla: editar o CEP sem recotar
       carimbava o resultado velho com o rotulo do CEP novo, e o drawer, que so
       confere peso e subtotal, exibia o frete de outro lugar como verdade. */
    if (c.cep !== dig(elCep.value) || c.peso !== st.peso || c.sub !== st.sub) { limpar(); return; }
    /* CEP herdado do chip de um presenteado e endereco de TERCEIRO: fica so em
       memoria (contrato do topo do arquivo). O drawer volta ao link de calcular. */
    if (c.fonte) { limpar(); return; }
    guardar('mw_compra_frete', JSON.stringify({
      cep: fcep(elCep.value),
      opcao: st.opcao,
      resultado: { nome: o.nome, valorCentavos: o.valorCentavos, prazoDiasUteis: o.prazoDiasUteis },
      pesoGramas: st.peso,
      subtotalCentavos: st.sub,
      ts: Date.now()
    }));
    guardar('mw_compra_cep', dig(elCep.value));
  }
  function limpar() { guardar('mw_compra_frete', ''); }

  function cotar(silencioso) {
    var d = dig(elCep.value);
    if (d.length !== 8) {
      st.frete = null;
      st.cot = null;
      seq++; /* cotacao em voo nao pode pintar depois disto */
      limpar();
      mt('fora', 0); /* mensagem de fora de area anterior nao convive com o erro de CEP */
      mt('ce', 1, T.cep_erro);
      pintar();
      return;
    }
    mt('ce', 0);
    if (!silencioso) mt('calcular', 1, T.cotando);
    /* Token de geracao + a tupla desta requisicao. Duas mudancas de carrinho
       proximas (dois cliques no stepper) geram cotacoes concorrentes: se a velha
       chegar depois, ela pintaria o preco de um carrinho que nao existe mais e
       viraria snapshot carimbado com o peso/subtotal de agora - justamente o que
       o drawer usa para acreditar no valor. */
    var meu = ++seq, ctx = { cep: d, peso: st.peso, sub: st.sub, fonte: st.fonte };
    fetch('/apps/curador/frete?cep=' + d + '&pesoGramas=' + ctx.peso + '&subtotalCentavos=' + ctx.sub, { headers: JSN })
      .then(function (r) { return rj(r).then(function (j) { j._s = r.status; return j; }); })
      .catch(function () { return { _s: 0 }; })
      .then(function (j) { if (meu === seq) aplicar(j, ctx); });
  }

  function aplicar(j, ctx) {
    mt('calcular', 1, T.calcular);
    var ops = j.ok && j.opcoes ? j.opcoes : null;
    st.frete = null;
    st.cot = null;
    mt('fora', 0);
    if (ops && ops.length) {
      st.frete = j;
      st.cot = ctx;
    } else if (j.ok || j.erro === 'fora_de_area') {
      /* fora de area: o contrato antigo previa opcoes vazio, a rota real responde
         404 sem UF - por isso o texto tem versao sem o estado */
      mt('fora', 1, j.uf ? fmt(T.fora_area, { uf: j.uf }) : T.fora_area_cep);
      limpar();
    } else if (j.erro === 'cep_invalido') {
      mt('ce', 1, T.cep_erro);
      limpar();
    } else if (j.erro === 'muitas_chamadas') {
      /* rate limit da rota (janela de 1 min, IP compartilhado chega la): e
         transitorio, entao o formulario continua na tela para tentar de novo */
      mt('ce', 1, T.aguarde);
      limpar();
    } else {
      /* Catch-all: backend fora, kill switch, tabela sem preco, assinatura ou
         parametro recusado - qualquer erro nao previsto cai na nota estatica no
         lugar do formulario. A compra nunca trava por causa da cotacao (HANDOFF
         3.3) e o estimador nunca some em silencio. */
      mt('ef', 0);
      mt('en', 1);
      limpar();
    }
    pintar();
  }

  function pintar() {
    var caixa = q('opcoes');
    var f = st.frete;
    var o = escolhida();
    if (o) st.opcao = o.nome; /* cotacao nova sem a opcao de antes: cai na primeira */
    caixa.textContent = '';
    (f ? f.opcoes : []).forEach(function (x) {
      var n = clonar('opcao');
      n.setAttribute('data-op', x.nome);
      if (x.nome === st.opcao) n.setAttribute('aria-pressed', 'true');
      slot(n, 'nome', x.nome);
      slot(n, 'prazo', fmt(T.chega_em, { a: x.prazoDiasUteis[0], b: x.prazoDiasUteis[1] }));
      var v = slot(n, 'valor', x.valorCentavos === 0 ? T.gratis : brl(x.valorCentavos));
      if (x.valorCentavos === 0) v.className += ' mw-cpg-op-val--gratis';
      caixa.appendChild(n);
    });

    var g = f ? (f.gratisAcima == null ? f.gratisAcimaCentavos : f.gratisAcima) : null;
    /* A linha verde so vale quando a opcao ESCOLHIDA e a gratuita: o corte zera a
       opcao padrao, mas a Expressa continua paga - anunciar "frete gratis
       aplicado" com ela selecionada contradiz o total logo abaixo. */
    var ating = !!f && g != null && st.sub >= g && !!o && o.valorCentavos === 0;
    var falta = !!f && g != null && st.sub < g;
    mt('go', ating, ating ? fmt(T.gratis_ok, { valor: brl(g) }) : null);
    mt('gf', falta);
    if (falta) {
      q('gb').style.width = Math.min(100, Math.round(st.sub / g * 100)) + '%';
      mt('gt', 1, fmt(T.gratis_faltam, { valor: brl(g - st.sub) }));
    }

    var total = o ? st.sub + o.valorCentavos : null;
    mt('total', !!o);
    if (o) {
      mt('tv', 1, brl(total));
      /* na cotacao gratis a rota nomeia a opcao "Frete gratis": sem este desvio
         a linha viraria "COM FRETE FRETE GRATIS" */
      mt('ts', 1, fmt(T.com_frete, { nome: (o.valorCentavos ? o.nome : T.gratis).toUpperCase() }));
    }
    mt('br', 1, o ? T.total_estimado : T.bar_subtotal);
    mt('bt', 1, brl(o ? total : st.sub));

    var hint = !!st.fonte && chk.checked;
    mt('ch', hint, hint ? fmt(T.usando_cep, { nome: st.fonte.toUpperCase() }) : null);

    var p = pessoa();
    var comEnd = !!(p && p.end && p.completo);
    mt('entrega', chk.checked && comEnd);
    if (comEnd) {
      var l = linhas(p.end);
      mt('eg-txt', 1, fmt(PREFILL ? T.entrega_prefill : T.entrega_planob, { nome: p.nome }));
      mt('eg-l1', 1, l[0]);
      mt('eg-l2', 1, l[1]);
    }
    mt('aviso', chk.checked && !comEnd);
    snapshot();
  }

  /* ---------- bloco de presente (so logado) ---------- */
  function pintarPresente() {
    var palco = q('palco');
    if (!palco) return;
    var caixa = q('chips');
    caixa.textContent = '';
    st.pres.concat([{ id: 'novo', nome: T.nova_pessoa }]).forEach(function (p) {
      var c = clonar('chip');
      c.textContent = p.id === 'novo' ? p.nome : p.nome + (p.relacao ? ' · ' + p.relacao : '');
      c.setAttribute('data-id', p.id);
      if (p.id === st.sel) c.setAttribute('aria-pressed', 'true');
      caixa.appendChild(c);
    });
    palco.hidden = false;

    var p = pessoa();
    var comEnd = !!(p && p.end && p.completo);
    var semEnd = !!p && !comEnd;
    var salvo = semEnd && st.sel !== 'novo';
    ve('novapessoa', st.sel === 'novo');
    ve('semend', semEnd && !st.aberto);
    mt('st', salvo, salvo ? fmt(T.sem_endereco, { nome: p.nome }) : null);
    ve('endform', st.aberto);
    ve('endsalvo', comEnd);
    if (comEnd) {
      var l = linhas(p.end);
      mt('es-rot', 1, fmt(T.entrega_salva, { nome: p.nome.toUpperCase() }));
      mt('es-l1', 1, l[0]);
      mt('es-l2', 1, l[1]);
    }
    /* pessoa que veio de evento: sem recado e sem email (semEm). O disabled tira
       o email do submit do form: o que nao esta na tela nao viaja. */
    var se = semEm();
    ve('recado', !se);
    ve('email', !se);
    if (em) em.disabled = se;
    validar();
    pintar();
  }

  /* attributes do carrinho: fonte de verdade de quem recebe (sobrevive ao
     re-render e chega ao pedido). Os hidden do form cobrem o caminho sem JS -
     e por isso tem que andar junto, senao o submit reescreve com o valor velho. */
  function atributos(id, nome) {
    q('pi').value = id || '';
    q('pn').value = nome || '';
    post('/cart/update.js', { attributes: { presenteado_id: id || '', presenteado_nome: nome || '', presenteado_email: emv() } })
      .catch(function () { /* o form ainda leva os hidden no submit */ });
  }

  /* Email mudou (change = saiu do campo com valor novo). Invalido nao grava
     nada: validar() aponta o campo no Finalizar, e o painel descarta o
     atributo. Valido (ou apagado) vai ao atributo do carrinho e, com pessoa
     salva escolhida, a ficha dela na conta: o painel usa o atributo e, sem ele,
     o email da FICHA, entao apagar aqui apaga la - senao o campo vazio mentiria
     e o email sairia mesmo assim. Pessoa nova ainda sem ficha leva o email no
     POST do criarPessoa. Pessoa de evento nao tem o campo (semEm). */
  function salvarEmail() {
    var v = em.value.trim(), p = achar(st.sel);
    if (semEm() || (v && !EM.test(v))) return;
    em.value = v;
    post('/cart/update.js', { attributes: { presenteado_email: v } }).catch(function () { /* o form leva o campo no submit */ });
    if (p && (p.email || '') !== v) {
      post(API + '/presenteados/' + encodeURIComponent(p.id), { email: v || null }, 'PUT')
        .then(function (r) { if (r.ok) p.email = v || null; })
        .catch(function () { /* o atributo do carrinho ainda leva o email */ });
    }
  }

  function ancorar(p) {
    if (!p || !p.end || !p.end.cep) { st.fonte = null; pintar(); return; }
    elCep.value = fcep(p.end.cep);
    st.fonte = p.nome;
    cotar(true);
  }

  function escolher(id) {
    var a = achar(id) || {};
    st.sel = id;
    st.aberto = false;
    mt('ee', 0);
    /* O campo passa ao email da pessoa escolhida quando ela tem um. Sem email
       (pessoa nova, salva sem email ou de evento), so sai o valor que era da
       pessoa anterior (emDe): o de uma pessoa nao pode ficar para a outra, e o
       digitado antes de escolher alguem nao se perde num toque de chip. */
    if (em) {
      if (a.email && !a.semEmailPresente) { em.value = a.email; emDe = id; }
      else if (emDe && emDe !== id) { em.value = ''; emDe = null; }
    }
    var p = pessoa();
    atributos(id === 'novo' ? '' : id, p ? p.nome : '');
    pintarPresente();
    ancorar(p);
    if (id === 'novo' && campo('nome')) campo('nome').focus();
  }

  /* O POST falhou (400 do schema ou rede fora): o endereco continua valendo nesta
     compra e viaja no checkout, mas a tela nao pode afirmar que ficou salvo na
     conta. Reabre o formulario, ja preenchido, com o aviso. */
  function naoSalvou() {
    st.aberto = true;
    pintarPresente();
    mt('ee', 1, T.end_nao_salvo);
  }

  function salvarEndereco() {
    var e = {
      cep: fcep(ler('cep')), endereco1: ler('endereco1'), endereco2: ler('endereco2'),
      bairro: ler('bairro'), cidade: ler('cidade'), uf: ler('uf').toUpperCase()
    };
    /* mesma regua do enderecoEntradaSchema do servidor (endereco1 min 3, bairro e
       cidade min 2, UF entre as 27): mais frouxo aqui virava 400 que a UI nao lia */
    if (dig(e.cep).length !== 8 || e.endereco1.length < 3 || e.bairro.length < 2
      || e.cidade.length < 2 || e.uf.length !== 2 || UFS.indexOf(e.uf) % 3 !== 0) {
      mt('ee', 1, T.end_erro);
      return;
    }
    mt('ee', 0);
    st.ends[st.sel] = e;
    st.aberto = false;
    if (SALVAR_ENDERECO && st.sel !== 'novo') {
      post(API + '/presenteados/' + encodeURIComponent(st.sel) + '/endereco', {
        cep: dig(e.cep), endereco1: e.endereco1, endereco2: e.endereco2 || null,
        bairro: e.bairro, cidade: e.cidade, uf: e.uf
      })
        .then(function (r) { if (!r.ok) naoSalvou(); })
        .catch(naoSalvou);
    }
    pintarPresente();
    ancorar(pessoa());
  }

  /* Nova pessoa: nasce na conta por ACAO EXPLICITA (botao "usar essa pessoa" ou
     Enter no campo de relacao), nunca no blur. Ate 2026-08-19 o `change` do nome
     criava a ficha a cada Tab: a pessoa nascia sem relacao e o formulario sumia
     sob o cursor, antes de a relacao ser digitada. Falhou o POST? o nome ainda
     viaja nos attributes e a compra segue. */
  function criarPessoa() {
    var nome = ler('nome');
    /* guard de reentrancia: Enter na relacao e clique no botao chamam os dois, e
       o campo so e limpo na resposta - sem a flag nascem duas fichas iguais */
    if (!nome || criando) return;
    criando = true;
    var relacao = ler('relacao');
    var email = emv() || null; /* digitado antes de a ficha existir: vai no proprio POST */
    atributos('', nome);
    post(API + '/presenteados', { nome: nome, relacao: relacao || null, email: email })
      .then(rj)
      .then(function (j) {
        criando = false;
        if (!j.ok || !j.id) return;
        st.pres.push({ id: j.id, nome: nome, relacao: relacao, email: email, endereco: st.ends.novo || null, enderecoCompleto: !!st.ends.novo });
        if (st.ends.novo) { st.ends[j.id] = st.ends.novo; delete st.ends.novo; }
        st.sel = j.id;
        if (email) emDe = j.id; /* o email foi no POST: agora e o da ficha dela */
        campo('nome').value = '';
        campo('relacao').value = '';
        atributos(j.id, nome);
        pintarPresente();
      })
      .catch(function () { criando = false; pintarPresente(); });
  }

  /* Quantidade digitada. Sem isto o campo so serve ao caminho sem JS - e pior:
     o Enter nele cairia no submit implicito do form, que e o Finalizar.
     Entra pelo MESMO motor dos botoes +/- (MWCart.mudar, key da linha): pintura
     otimista, um POST por vez e rollback em falha, tudo de graca aqui. */
  function mudarQtd(t) {
    var li = t.closest('[data-key]');
    if (li && window.MWCart) window.MWCart.mudar(li.getAttribute('data-key'), parseInt(t.value, 10) || 0);
  }

  /* ---------- eventos ---------- */
  raiz.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-a],[data-mw-cchip],[data-mw-op]');
    if (!b) return;
    /* cchip = chip do CARRINHO. `data-mw-chip` e do Curador, que escuta no
       document e abria a drawer dele no clique de "+ Nova pessoa" daqui. */
    if (b.hasAttribute('data-mw-cchip')) { escolher(b.getAttribute('data-id')); return; }
    if (b.hasAttribute('data-mw-op')) {
      st.opcao = b.getAttribute('data-op');
      pintar(); /* o repaint troca os botoes: o foco volta pra opcao escolhida */
      var novo = raiz.querySelector('[data-op="' + st.opcao + '"]');
      if (novo) novo.focus();
      return;
    }
    var a = b.getAttribute('data-a');
    if (a === 'calcular') cotar(false);
    else if (a === 'add-end') {
      /* o form e um so: aberto para OUTRA pessoa, nao pode mostrar (nem salvar)
         o endereco digitado para a anterior. naoSalvou() reabre por fora daqui
         e PRESERVA os valores, como deve. */
      ['cep', 'endereco1', 'endereco2', 'bairro', 'cidade', 'uf'].forEach(function (f) {
        var c = campo(f); if (c) c.value = '';
      });
      cepAu = {}; cepUlt = '';
      st.aberto = true; pintarPresente(); campo('cep').focus();
    }
    else if (a === 'salvar-end') salvarEndereco();
    else if (a === 'usar') criarPessoa(); /* mesma acao explicita do card da pagina de envios */
  });

  raiz.addEventListener('input', function (ev) {
    var t = ev.target;
    if (t === elCep) {
      t.value = fcep(t.value);
      st.fonte = null;
      mt('ch', 0);
      mt('fora', 0); /* fora de area e da cotacao anterior; some ao editar */
      /* Editar o CEP invalida a cotacao que esta na tela: opcoes, total e
         snapshot sao de outro lugar. Volta ao estado "calcule" ate recotar. */
      if (st.cot && st.cot.cep !== dig(t.value)) {
        st.frete = null;
        st.cot = null;
        seq++;
        limpar();
        pintar();
      }
    } else {
      if (t === em) {
        /* digitado com pessoa salva escolhida e o email dela; sem, e livre */
        emDe = achar(st.sel) ? st.sel : null;
        validar();
        return;
      }
      var f = t.getAttribute('data-f');
      if (f === 'cep') { t.value = fcep(t.value); cepAuto(); }
      else if (f) delete cepAu[f]; /* digitou no campo: o autocomplete nao manda mais nele */
    }
  });

  /* Enter dentro do card/estimador nao pode disparar o submit implicito do form
     (o primeiro submit e o Finalizar: iria direto pro checkout). */
  raiz.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var t = ev.target;
    if (t.tagName !== 'INPUT') return;
    ev.preventDefault();
    var f = t.getAttribute('data-f');
    if (t === elCep) cotar(false);
    else if (t.type === 'number') mudarQtd(t);
    /* Enter no nome so ANDA o foco: quem cria a pessoa e a relacao (Enter) ou o
       botao. Assim ninguem nasce na conta sem relacao por causa de um Enter. */
    else if (f === 'nome') { var rel = campo('relacao'); if (rel) rel.focus(); }
    else if (f === 'relacao') criarPessoa();
    else if (f) salvarEndereco();
  });

  raiz.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t === chk) {
      /* Desmarcou: os espelhos locais morrem junto com os attributes que o
         mw-cart.js acabou de limpar no servidor. Sem isto o submit nativo do form
         reenviaria os hidden com o presenteado velho e o pedido nasceria vinculado
         a alguem que o cliente disse nao ser presente. */
      if (!chk.checked) {
        st.sel = null;
        st.fonte = null;
        st.aberto = false;
        var i = q('pi'), n = q('pn');
        if (i) i.value = '';
        if (n) n.value = '';
        /* o email tambem (o atributo ja foi limpo pelo mw-cart.js): e o
           vinculo velho, e validar() abaixo tira a marca de invalido dele */
        if (em) em.value = '';
        emDe = null;
      }
      var palco = q('palco');
      if (palco && !palco.hidden) pintarPresente();
      else pintar();
      validar();
    } else if (t === em) salvarEmail();
    else if (t.type === 'number') mudarQtd(t);
    /* o `change` do campo de nome NAO cria mais a pessoa: Tab/blur saia daqui
       gravando ficha sem relacao (achado da compra-teste, 2026-08-19). */
  });

  /* ---------- carrinho ao vivo ---------- */
  document.addEventListener('mw:cart', function (ev) {
    var c = ev.detail;
    if (!c) return;
    var mudou = st.peso !== c.total_weight || st.sub !== c.items_subtotal_price;
    st.peso = c.total_weight;
    st.sub = c.items_subtotal_price;
    var primeiro = !st.vivo;
    st.vivo = true;
    mt('subtotal', 1, brl(st.sub));
    mt('garrafas', 1, c.item_count === 1 ? T.g1
      : fmt(T.gn, { n: (c.item_count < 10 ? '0' : '') + c.item_count }));
    if (primeiro && !elCep.value) {
      var salvo = '';
      try { salvo = localStorage.getItem('mw_compra_cep') || ''; } catch (e) { /* bloqueado */ }
      if (dig(salvo).length === 8) { elCep.value = fcep(salvo); cotar(true); return; }
    }
    /* mexeu na quantidade ou trocou de rotulo: a cotacao de antes virou mentira */
    if (mudou && st.frete && dig(elCep.value).length === 8) cotar(true);
    else pintar();
  });

  /* ---------- boot ---------- */
  pintar();
  validar(); /* o email que voltou do atributo tambem passa pela regua */
  if (LOGADO) {
    /* /eu e a sentinela da sessao: o logged_in_customer_id do App Proxy tem
       historico de vir vazio (bug intermitente das new customer accounts). Sem
       sessao visivel ou com a conta fora do ar, o carrinho segue inteiro - so
       nao aparece o bloco de PII. */
    Promise.all([jget(API + '/eu'), jget(API + '/presenteados')]).then(function (r) {
      if (!r[0].logado || !r[1].ok || !r[1].presenteados) return;
      st.pres = r[1].presenteados;
      var atual = q('pi');
      st.sel = atual && achar(atual.value) ? atual.value : null;
      /* pessoa ja escolhida antes do reload: campo vazio recebe o email dela, e
         o valor que esta no campo passa a ser dela (emDe) */
      var ja = achar(st.sel);
      if (em && ja) {
        if (ja.email && !ja.semEmailPresente && !em.value) em.value = ja.email;
        emDe = ja.id;
      }
      pintarPresente();
      var p = pessoa();
      if (p && p.end && chk.checked) ancorar(p);
    }).catch(function () { /* carrinho segue sem o bloco */ });
  }
})();
